"use client";

import { queryClient } from "@/config/react-query";
import { useWebSocketCallbackSubscription } from "@/hooks/use-websocket-subscription";
import type { AlertDetail } from "@/types/alert";
import { AlertType } from "@/types/enums/alert-type";
import type { AnsweredFormTiny } from "@/types/forms/answered-form";
import type { PatientSubmissionTableItem, PatientSubmissionsTable } from "@/types/forms/form";
import { formQueryKeys } from "@/api/forms/form-query";
const FORM_SUBMITTED_ALERT_TYPES = [AlertType.FORM_SUBMITTED];

/** Keeps cached form submissions current when a patient submits a form. */
export function useFormSubmissionRealtimeCache() {
  useWebSocketCallbackSubscription(FORM_SUBMITTED_ALERT_TYPES, handleFormSubmitted, true, "useFormSubmissionRealtimeCache");
}
function handleFormSubmitted(message: AlertDetail) {
  const submission = message.data as AnsweredFormTiny;
  const formId = submission.formId;
  if (!formId) return;

  // The server sends FORM_SUBMITTED only for complete submissions.
  const row: PatientSubmissionTableItem = {
    patient: submission.patient,
    formId,
    answeredFormId: submission.id,
    submissionDate: submission.submissionDate,
    hadUploadError: false,
    isCompleted: true,
    expiresAt: submission.expiresAt,
    isExpired: false
  };
  queryClient.setQueryData<PatientSubmissionsTable | null>(formQueryKeys.submissions(submission.patient.id), prev => {
    if (!prev) return prev;
    const others = prev.data.filter(item => item.answeredFormId !== submission.id);
    const isNew = others.length === prev.data.length;
    return {
      data: [row, ...others],
      total: prev.total + (isNew ? 1 : 0)
    };
  });
}